import React, { useEffect, useState, useCallback } from 'react';
import { useAxios } from '../../../Helpers/AxiosHelper';
import { Column, DataTable, Dialog } from '../../../Common/Imports';
import { ApiResponse, Pax_EXT } from '../../../Models/Classes';
import { FormatDateTime } from '../../../Common/Utility/FormatDateTime';

interface OperativePaxesProps {
    IDReservation: number;
}

export const OperativePaxes: React.FC<OperativePaxesProps> = ({ IDReservation }) => {
    const AxiosHelper = useAxios();
    const [visible, setVisible] = useState<boolean>(true);
    const [data, setData] = useState<Pax_EXT[] | undefined>();

    const GetData = useCallback(async () => {

        try {
            const resp = await AxiosHelper.get<ApiResponse<Pax_EXT[]>>(`Operative/GetReservationPaxes/${IDReservation}`);
            if (resp.data.code === 0) {
                const processedData = resp.data.data.map(item => ({
                    ...item,
                    dateOfBirth: item.dateOfBirth ? new Date(item.dateOfBirth) : undefined,
                }));
                setData(processedData);
                setVisible(true);
            }
        } catch (error) {
            console.error('Error fetching property contacts:', error);
        }
    }, [AxiosHelper, IDReservation]);

    useEffect(() => {
        GetData();
    }, [GetData]);

    return (
        <Dialog header="Paxes" visible={visible} onHide={() => setVisible(false)}>
            {data &&
                <DataTable
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    value={data}
                    size="small"
                    stripedRows
                    tableStyle={{ minWidth: '50rem' }}>
                    <Column
                        header="Index"
                        field="paxIndex"
                        bodyClassName="table-cell-nowrap" />
                    <Column
                        header="Name"
                        field="name"
                        bodyClassName="table-cell-nowrap" />
                    <Column
                        header="Surname"
                        field="surname"
                        bodyClassName="table-cell-nowrap" />
                    <Column
                        header="Middle Name"
                        field="middleName"
                        bodyClassName="table-cell-nowrap" />
                    <Column
                        header="Gender"
                        field="gender"
                        bodyClassName="table-cell-nowrap" />
                    <Column
                        header="Date of Birth"
                        field="dateOfBirth"
                        body={(rowData) => FormatDateTime(rowData.dateOfBirth)}
                        bodyClassName="table-cell-nowrap" />
                </DataTable>
            }
        </Dialog >
    );
};

export default OperativePaxes;
